import { DatePicker } from '@mui/x-date-pickers';

/* NPM */
import { startOfQuarter } from 'date-fns';
import dayjs from 'dayjs';

/* React */
import React, { useState } from 'react';

import { Day } from './CustomPickersDay';

export const QuarterPicker = ({
    disableFuture,
    onChange,
    value: incomingValue
}) => {
    const [value, setValue] = useState(
        startOfQuarter(new Date(incomingValue) || new Date())
    );

    return (
        <DatePicker
            value={dayjs(value)}
            disableFuture={disableFuture}
            onChange={(newValue) => {
                setValue(dayjs(startOfQuarter(new Date(newValue))));
                onChange(dayjs(startOfQuarter(new Date(newValue))));
            }}
            slots={{ day: Day }}
            slotProps={{
                day: {
                    pickerType: 'quarter',
                    selectedDay: dayjs(startOfQuarter(new Date(value)))
                }
            }}
        />
    );
};
